import { defineMessages } from 'react-intl';

export default defineMessages({
  closeModal: {
    id: 'FreeGiftAOV.closeModal',
    description: 'Close modal button aria-label',
    defaultMessage: 'Close modal',
  }
});
